import { useState, useEffect } from "react";
import axios from "axios";
import SimpleLineChart from "../../../components/charts/SimpleLineChart";
import GaugeChart from "../../../components/charts/GaugeChart";
const MainDashboard = () => {

  const [devices, setDevices] = useState([]);
  const [collapsedGroups, setCollapsedGroups] = useState({});
  useEffect(() => {
    const loadData = async () => {
      try {
        const response = await axios.post("/web/devices/home/data", {});
        if (response.data.success) {
          // convierte la fecha de texto a fecha
          response.data.data.forEach((device) => {
            device.data.forEach((row) => {
              row.f = new Date(row.f);
            });
          });

          setDevices(response.data.data);
        }
      } catch (error) {
        console.error("Error loading data:", error);
      }
    };

    loadData();

    const interval = setInterval(loadData, 30000);

    // Limpieza al desmontar
    return () => clearInterval(interval);
  }, []);

  // Agrupar dispositivos por grupo
  const devicesByGroup = devices.reduce((acc, device) => {
    if (!acc[device.grupo]) {
      acc[device.grupo] = [];
    }
    acc[device.grupo].push(device);
    return acc;
  }, {});

  // Inicializar el estado de colapso cuando los dispositivos cambien
  useEffect(() => {
    if (devices.length > 0) {
      const grupos = [...new Set(devices.map(device => device.grupo))];
      const initialCollapsed = {};
      grupos.forEach((grupo, index) => {
        // El primer grupo (index 0) está expandido (false), los demás colapsados (true)
        initialCollapsed[grupo] = index !== 0;
      });
      setCollapsedGroups(initialCollapsed);
    }
  }, [devices]);

  // Función para alternar el estado de colapso de un grupo
  const toggleGroup = (grupo) => {
    setCollapsedGroups(prev => ({
      ...prev,
      [grupo]: !prev[grupo]
    }));
  };

  return (
    <div className="mt-3">
      <div className="grid gap-6">
        {Object.entries(devicesByGroup).map(([grupo, groupDevices]) => (
          <div key={grupo} className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm dark:border-gray-700 dark:bg-navy-800">
            <div className="flex items-center justify-between mb-4 border-b border-gray-200 dark:border-gray-600 pb-2">
              <h2 className="text-xl font-bold text-gray-800 dark:text-white">
                {grupo}
              </h2>
              <button
                onClick={() => toggleGroup(grupo)}
                className="flex items-center gap-2 rounded-md bg-gray-100 px-3 py-1 text-sm font-medium text-gray-700 hover:bg-gray-200 dark:bg-navy-700 dark:text-white dark:hover:bg-navy-600 transition-colors"
              >
                {collapsedGroups[grupo] ? (
                  <>
                    <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                    Mostrar
                  </>
                ) : (
                  <>
                    <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                    </svg>
                    Ocultar
                  </>
                )}
              </button>
            </div>
            {!collapsedGroups[grupo] && (
              <div className="grid gap-4">
                {groupDevices.map((device) => (
                  <div key={device.nombre} className="rounded border border-gray-100 bg-gray-50 p-3 dark:border-gray-600 dark:bg-navy-700">
                    <h3 className="mb-2 font-semibold text-gray-700 dark:text-white">
                      {device.nombre}
                    </h3>
                    <div className="h-[400px] w-full">
                      <SimpleLineChart device={device} />
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MainDashboard;
